'use client'

import type { ReactNode } from 'react'

import { configPublic } from '@src/config.public'
import { getBuilderPreviewMode } from '@src/utils/builder.util'
import { cn } from '@src/utils/tailwind'

interface ShopifyEnabledConditionalContentProps {
  attributes: any
  className?: string
  showIfShopifyEnabled: boolean
  children: ReactNode
}

export function ShopifyEnabledConditionalContent(props: ShopifyEnabledConditionalContentProps) {
  const { attributes, className, showIfShopifyEnabled, children } = props
  const { edit } = getBuilderPreviewMode()
  const content = (
    <div
      {...attributes}
      key={attributes?.key}
      className={cn('size-auto', className, attributes?.className, {
        'border-4 border-green-400 relative': edit,
      })}
      style={{ ...attributes?.style }}
      suppressHydrationWarning
    >
      {children}
    </div>
  )
  if (edit) return content
  if (showIfShopifyEnabled && configPublic.featureFlags.shopifyEnabled) return content
  if (!showIfShopifyEnabled && !configPublic.featureFlags.shopifyEnabled) return content
  return null
}
